import { SpliApiError } from "@spli/api-client";
import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon.js";

export function LoadingView({ label = "読み込み中…" }: { label?: string }) {
  return (
    <div className="empty-state" role="status">
      <span className="empty-state__icon">
        <Icon name="loading" size={32} />
      </span>
      {label}
    </div>
  );
}

export function ErrorView({ error }: { error: unknown }) {
  const message =
    error instanceof SpliApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : "エラーが発生しました";

  return (
    <div className="notice notice--warning" role="alert">
      {message}
    </div>
  );
}

export function EmptyState({ icon, children }: { icon: IconName; children: ReactNode }) {
  return (
    <div className="empty-state">
      <span className="empty-state__icon">
        <Icon name={icon} size={32} />
      </span>
      {children}
    </div>
  );
}
